export const limitedCompanyCriteria = {
  heading: 'ltd-co-criteria-heading',

  // Section test ids
  companySection: 'company-section',
  applicationSection: 'application-section',
  customerSection: 'customer-section',
  incomeSection: 'income-section',
  lendingSection: 'lending-section',
  propertySection: 'property-section',
  existingCustomerSection: 'existing-customer-section',

  // Section heading test ids
  companyHeading: 'company-heading',
  applicationHeading: 'application-heading',
  customerHeading: 'customer-heading',
  incomeHeading: 'income-heading',
  lendingHeading: 'lending-heading',
  propertyHeading: 'property-heading',
  existingCustomerHeading: 'existing-customer-heading',

  // CompanySection accordions
  companyStructure: 'company-structure',
  directorsShareholders: 'directors-shareholders',
  applicationCriteria: 'application-criteria',
  tenancyCriteria: 'tenancy-criteria',
  sourceOfDeposit: 'source-of-deposit',

  // ApplicationSection accordions
  directorsAndShareholders: 'directors-and-shareholders',
  decisionInPrinciple: 'decision-in-principle',
  directDebitDetails: 'direct-debit-details',

  // CustomerSection accordions
  expatriates: 'expatriates',
  howToCertifyADocument: 'how-to-certify-a-document',
  idAddressVerification: 'id-address-verification',
  foreignNationals: 'foreign-nationals',
  refugees: 'refugees',

  // IncomeSection accordions
  affordabilityAndSustainability: 'affordability-and-sustainability',
  directorsOrShareholdersNotPaidInSterling:
    'directors-or-shareholders-not-paid-in-sterling',
  contractors: 'contractors',
  incomeTypes: 'income-types',
  lengthOfEmploymentSelfEmployment: 'length-of-employment-self-employment',
  rentalIncome: 'rental-income',
  secondJob: 'second-job',
  selfEmployedDirectorsOrShareholders:
    'self-employed-directors-or-shareholders',
  selfEmployedContractors: 'self-employed-contractors',
  taxOnRentalIncome: 'tax-on-rental-income',

  // LendingSection accordions
  assignableContracts: 'assignable-contracts',
  bankruptcies: 'bankruptcies',
  businessConsumerBTL: 'business-consumer-btl',
  concessionaryPurchase: 'concessionary-purchase',
  countyCourtJudgements: 'county-court-judgements',
  creditScoreDeclineAppeals: 'credit-score-decline-appeals',
  dependants: 'dependants',
  deposits: 'deposits',
  firstTimeBuyerFirstTimeLandlord: 'first-time-buyer-first-time-landlord',
  lettingCriteria: 'letting-criteria',
  lendingLimits: 'lending-limits',
  minMaxAge: 'min-max-age',
  minMaxTerm: 'min-max-term',
  mortgageArrears: 'mortgage-arrears',
  mortgageFreeUnencumberedProperties: 'mortgage-free-unencumbered-properties',
  notionalStressRates: 'notional-stress-rates',
  portfolioLandlords: 'portfolio-landlords',
  remortgageAndCapitalRaising: 'remortgage-and-capital-raising',
  repaymentMethods: 'repayment-methods',

  // PropertySection accordions
  location: 'location',
  builderCashIncentives: 'builder-cash-incentives',
  buyToLetPropertyAddress: 'buy-to-let-property-address',
  cladding: 'cladding',
  condition: 'condition',
  construction: 'construction',
  distressedSaleAndLeaseback: 'distressed-sale-and-leaseback',
  energyPerformanceCertificate: 'energy-performance-certificate',
  exposureLimits: 'exposure-limits',
  freeValuations: 'free-valuations',
  housesInMultipleOccupations: 'houses-in-multiple-occupations',
  japaneseKnotweed: 'japanese-knotweed',
  newBuild: 'new-build',
  revisedPropertyDetails: 'revised-property-details',
  scottishValuations: 'scottish-valuations',
  subSalesAndBackToBackTransactions: 'sub-sales-and-back-to-back-transactions',
  tenure: 'tenure',
  unacceptableConstructionTypes: 'unacceptable-construction-types',
  useOfProperty: 'use-of-property',
  valuation: 'valuation',

  // ExistingCustomerSection accordions
  arrears: 'arrears',
  ercs: 'ercs',
  furtherAdvances: 'further-advances',
  overpayments: 'overpayments',
  paymentHolidays: 'payment-holidays',
  portability: 'portability',
  productTransfers: 'product-transfers',
  productTransferTimescales: 'product-transfer-timescales',
};
